import React from 'react';
import ReceiptTester from '../components/testing/ReceiptTester';
import './DevTools.scss';

/**
 * A development tools page that can be used to test various features
 * This is intended for development use only and should be disabled in production
 */
function DevTools() {
  return (
    <div className="dev-tools-page">
      <div className="dev-tools-header">
        <h1>Development Tools</h1>
        <p className="warning">
          These tools are for development purposes only and should not be used in production.
        </p>
      </div>

      <div className="dev-tools-content">
        <div className="tools-section">
          <h2>API Testing Tools</h2>
          <ReceiptTester />
        </div>

        {/* Add more development tools here as needed */}
      </div>
    </div>
  );
}

export default DevTools; 